import { render, staticRenderFns } from "./status-dot.vue?vue&type=template&id=0656d834&"
import script from "./status-dot.vue?vue&type=script&lang=js&"
export * from "./status-dot.vue?vue&type=script&lang=js&"
import style0 from "./status-dot.vue?vue&type=style&index=0&id=0656d834&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports